import { ImageViewerContainer } from "@/components/Product/ImageViewer/imageViewer.container";

import { useProductPageContext } from "../../context/productPage.context";

export const ProductPageImageViewerContainer = () => {
    const { product, images, videos, usesDefaultImage } =
        useProductPageContext();

    return (
        <ImageViewerContainer
            title={product.productTitle}
            images={images}
            videos={videos}
            ecoChequesAccepted={product.ecochequesAccepted}
            usesdefaultimage={usesDefaultImage}
        />
    );
};
